import { runInitialAssistantTurn } from '@/features/chat/runInitialAssistantTurn'
import { buildUserAndPendingMessages } from './buildUserAndPendingMessages'
import { priorMessagesWithoutPending } from './priorMessagesWithoutPending'

/** @param {Record<string, unknown[]>} prev @param {Record<string, unknown>} opts */
export function appendInitialSendMessages(prev, opts) {
  const { tid, trimmed, files, mode, signal, setMessagesByThreadId, connectContext } = opts
  const priorMessages = priorMessagesWithoutPending(prev, tid)
  const now = Date.now()
  const { userMsg, pendingId, pendingAssistant } = buildUserAndPendingMessages({
    trimmed,
    files,
    versionIndex: 0,
    now,
    includeAgentMeta: true,
  })
  const apiMessages = [...priorMessages, userMsg].map((msg) => ({
    role: msg.role,
    content:
      msg.id === userMsg.id && !msg.text && files?.length
        ? 'Use the attached file(s) as context for this conversation.'
        : msg.text,
  }))
  runInitialAssistantTurn({
    tid,
    pendingId,
    trimmed,
    apiMessages,
    files,
    mode,
    signal,
    setMessagesByThreadId,
    allowResponseComponentDemo: true,
    connectContext,
  })
  return { ...prev, [tid]: [...priorMessages, userMsg, pendingAssistant] }
}
